import Vue from 'vue'
import router from '@/router'
import { messages } from '@/locale'

const redirectToLogin = () => {
  window.localStorage.removeItem('operator_access_token')
  location.reload()
}

export const responseSuccessInterceptor = response => {
  return response
}

export const responseErrorInterceptor = error => {
  const { response } = error
  const { status, data } = response
  const { fa } = messages
  const messageCodes = [400, 402, 403, 409, 500]
  let message = fa.server_error

  if (data && data.message) {
    message = data.message
  }
  if (status === 401) {
    let pageName = router.history.current.name
    if (pageName !== 'login') {
      redirectToLogin()
    } else {
      Vue.prototype.$message({
        message: fa.invalid_grant,
        type: 'error'
      })
    }
  }

  if (messageCodes.indexOf(status) > -1) {
    Vue.prototype.$message({
      message,
      type: 'error'
    })
  }

  return Promise.reject(error)
}
